"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tslib = require("tslib");

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

var _useDeepCompareEffect = _interopRequireDefault(require("../useDeepCompareEffect"));

var _useGlobalState = require("../useGlobalState");

var _getCancelInfo = _interopRequireDefault(require("./getCancelInfo"));

var _useAsyncRequest = _interopRequireDefault(require("./useAsyncRequest"));

var _sharedRequest = require("./sharedRequest");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


var useRequest = function useRequest(_a, isAsync) {
  var method = _a.method,
      path = _a.path,
      params = _a.params,
      headers = _a.headers;

  if (isAsync === void 0) {
    isAsync = false;
  }

  if (isAsync) {
    return (0, _useAsyncRequest["default"])({
      method: method,
      path: path,
      params: params,
      headers: headers
    });
  }

  var _b = (0, _getCancelInfo["default"])(),
      source = _b.source,
      cancelToken = _b.cancelToken;

  var devPrefix = (0, _useGlobalState.useGlobalState)('apiLocation')[0];

  var _c = (0, _react.useState)({
    data: undefined,
    isLoading: true,
    isErrored: false,
    exception: undefined,
    forceCancel: source.cancel
  }),
      state = _c[0],
      setState = _c[1];

  var url = devPrefix ? "" + devPrefix + path : path;
  var additionalHeaders = headers ? (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _sharedRequest.baseHeaders)()), headers) : (0, _tslib.__assign)({}, (0, _sharedRequest.baseHeaders)());
  var axiosOptions = {
    method: method,
    url: url,
    headers: additionalHeaders,
    cancelToken: cancelToken
  };

  if ((0, _sharedRequest.hasParams)(method)) {
    axiosOptions.params = params;
  }

  if ((0, _sharedRequest.hasData)(method)) {
    axiosOptions.data = params;
  }

  var fetchData = function fetchData() {
    (0, _axios["default"])((0, _tslib.__assign)({}, axiosOptions)).then(function (result) {
      setState((0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
        data: result.data,
        isLoading: false
      }));
    })["catch"](function (exception) {
      var localException = exception;

      if (_axios["default"].isCancel && _axios["default"].isCancel(exception)) {
        localException = (0, _tslib.__assign)((0, _tslib.__assign)({}, localException), {
          message: 'Cancelled request'
        });
      }

      setState((0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
        isLoading: false,
        isErrored: true,
        exception: localException
      }));
    });
  };

  var resetRequestLoadingState = function resetRequestLoadingState() {
    return setState((0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
      isLoading: true,
      isErrored: false
    }));
  };

  (0, _useDeepCompareEffect["default"])(function () {
    fetchData();
    return function () {
      return resetRequestLoadingState();
    };
  }, [params]);
  return state;
};

var _default = useRequest;
exports["default"] = _default;